import React, { useCallback, useEffect, useState } from 'react';
import './QuestsPage.css'; // Подключаем стили

const QuestsPage = ({ setClickCount,clickCount, username, setAvailableQuests, fetchUserData, triggerToast,realuserID,availableQuests,completedQuests, triggerIncomeAnimation, }) => {
  const [dailyCooldown, setDailyCooldown] = useState('');
  const [dailyAmount, setDailyAmount] = useState(null);
  const [claiming, setClaiming] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false); // Состояние для управления выдвижным окном
  const [selectedQuest, setSelectedQuest] = useState(null); // Состояние для выбранного квеста

  const fetchDailyCooldown = useCallback(async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users/get_user_claims`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username }),
      });
  
      if (!response.ok) throw new Error('Не удалось загрузить награду');
      const data = await response.json();
      setDailyAmount(Number(data.daily_amount));
      const lastDailyClaim = new Date(data.last_daily_claim); // Время последнего получения
      const now = new Date(); // Текущее время клиента
  
      console.log('Current time (client):', now);
      console.log('Last daily claim (from server):', lastDailyClaim);
  
      const nextDailyClaim = new Date(lastDailyClaim.getTime() + 24 * 60 * 60 * 1000); // Добавляем 24 часа
      const timeRemaining = nextDailyClaim.getTime() - now.getTime(); // Разница во времени в миллисекундах
  
      if (timeRemaining <= 0) {
        setDailyCooldown('Забрать!'); // Доступно для получения
      } else {
        const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        setDailyCooldown(`${hours}ч ${minutes}м`); // Обновляем состояние
      }
    } catch (error) {
      console.error('Ошибка при загрузке времени до следующего дейлика:', error);
    } finally {
    }
  }, [username]);

  const fetchQuests = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/quests/users/${realuserID}/quests`);
      if (!response.ok) throw new Error('Failed to fetch quests');
      const data = await response.json();
      setAvailableQuests(data.availableQuests);
    } catch (err) {
    } finally {
    }
  };


  const claimDailyReward = async () => {
  if (claiming || dailyCooldown !== 'Забрать!') return;
  setClaiming(true);
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/rewards/daily`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: username }),
    });

    const data = await response.json();
    if (response.ok) {
      fetchDailyCooldown();
      await fetchUserData(username);
      const amount = Number(data.amount) || 3000;
      triggerToast(`Ежедневная награда: +${amount.toLocaleString('ru-RU')} кликов`);
      triggerIncomeAnimation(amount);
      setClickCount(Number(data.click_count));
    } else {
      triggerToast(data.message || 'Не удалось получить награду');
    }
  } catch (error) {
    triggerToast('Не удалось получить награду. Попробуйте ещё раз.');
  } finally {
    setClaiming(false);
  }
};



  const handleQuestComplete = async (questId, link, type) => {
    try {
      const userId = realuserID;
      const questCheckResponse = await fetch(`${process.env.REACT_APP_API_URL}/quests/complete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, questId }),
      });
      const response = await questCheckResponse.json();
      if (questCheckResponse.ok) {
        setClickCount(Number(response.clickCount));
        await fetchUserData(username);
        triggerToast(`Задание выполнено: +${Number(response.reward)} кликов`);
        if (type === 'link' && link) {
          window.open(link, '_blank'); 
          setIsDrawerOpen(false);
        }
      } else {
        triggerToast('Ошибка завершения квеста: ' + response.message);
      }
    } catch (error) {
      console.error('Ошибка завершения квеста:', error);
      triggerToast('Произошла ошибка ');
    } finally {
      fetchQuests();
      setIsDrawerOpen(false);
    }
  };

  const handleQuestCheck = async (quest) => {
    setSelectedQuest(quest); 
    setIsDrawerOpen(true); 

  };
  const handleOpenTelegram = (channelLink) => {
    window.open(channelLink, '_blank');
  };
  useEffect(() => {
    fetchDailyCooldown();
    const timer = setInterval(fetchDailyCooldown, 60000);
    return () => clearInterval(timer);
  }, [fetchDailyCooldown]);


  return (
    <div className='container_ quests-modern'>
      <header className="quests-hero">
        <span>Центр наград</span>
        <h1>Квесты</h1>
        <p>Выполняйте задания и забирайте суточный доход.</p>
      </header>
      <section className="daily-vault">
        <div className="daily-vault__top"><span className="eyebrow">КАЖДЫЕ 24 ЧАСА</span><span className="status-pill">{dailyCooldown === 'Забрать!' ? 'Доступно' : dailyCooldown || 'Загрузка…'}</span></div>
        <div className="daily-vault__body"><div><h2>Ваша ежедневная награда</h2><strong className="daily-vault__amount">{dailyAmount === null ? '…' : `+${dailyAmount.toLocaleString('ru-RU')}`}</strong><p>3 000 бонуса + {dailyAmount === null ? '…' : Math.max(0, dailyAmount - 3000).toLocaleString('ru-RU')} дохода</p></div><img src="/assets/imgur/9mNiezg.png" alt="" /></div>
        <button className="game-primary" onClick={claimDailyReward} disabled={claiming || dailyCooldown !== 'Забрать!'}>{claiming ? 'Получаем…' : dailyCooldown === 'Забрать!' ? 'Забрать награду' : `Следующая награда через ${dailyCooldown || '…'}`}</button>
        <small>Весь доход от карт и улучшений + 3 заряда энергии</small>
      </section>

      <h2 className="quests-section-title">Дополнительные задания</h2>
      {availableQuests.length > 0 ? (
        availableQuests.map((quest) => (
          <button type="button" key={quest.id} className='element quest-list-item' onClick={() => handleQuestCheck(quest)}>
            <img src={`${quest.icon}.png`} alt={quest.name} />
            <div className='group'>
              <div className='info_row quest-list-title'>{quest.title}</div>
              <div className='info_row_sub'>
                <img src='/assets/currency-coin-v2.png' alt='' />
                <span>+{quest.reward}</span>
              </div>
            </div><span className="quest-arrow">↗</span>
          </button>
        ))
      ) : (
        <p>Нет доступных квестов.</p>
      )}

      {isDrawerOpen && (
        <div className='drawer'>
          <button className='qst_btn' style={{width: '25px', height: '25px', backgroundColor: 'transparent',}} onClick={() => setIsDrawerOpen(false)}>X</button>
          <img src={`${selectedQuest.icon}.png`} alt={selectedQuest.name} />
          <h4 style={{ fontSize: '25px' }}>{selectedQuest.title}</h4>
          <div className='zaeb'>
                <img src='/assets/currency-coin-v2.png' alt='' />
                <span style={{ fontSize: '20px' }}>+{selectedQuest.reward}</span>
              </div>
          <div className='drawer-buttons'>
            {selectedQuest.type === 'tg' && (
              <button className='qst_btn' style={{ backgroundColor: 'black' }} onClick={() => handleOpenTelegram(selectedQuest.requirements)}>Канал</button>
            )}
            <button className='qst_btn' style={{backgroundColor: 'transparent',}} onClick={() => handleQuestComplete(selectedQuest.id, selectedQuest.requirements, selectedQuest.type)}>Проверить</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuestsPage;
